//@flow
import * as React from 'react';

import { Route, Switch } from 'react-router-dom';
import ClienteCrudList from './ClienteCrudList';
import ClienteEdit from './ClienteEdit';

export default class ClienteCrud extends React.PureComponent<{}> {
  render() {
    return (
      <React.Fragment>
        <Switch>
          <Route path="/cliente" exact component={ClienteCrudList} />
          <Route path="/cliente/novo" exact component={ClienteEdit} />
          <Route path="/cliente/:id" component={ClienteEdit} />
        </Switch>
      </React.Fragment>
    );
  }
}
